import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { LOCALE, REGION_CODE } from '../libs/constants';
import default_lang from './messages/en.json';

import actions from '../store/actions/index';

function Langs(props) {
    let dispatch = useDispatch();
    const { app } = useSelector(state => state);
    if (!app.messagesReceived) {
    //     import("./messages/" + REGION_CODE + "/" + LOCALE + ".json").then(messages => {
    //        dispatch(actions.app.setMessages({ ...default_lang, ...messages }));
    //     }).catch(() => {
            dispatch(actions.app.setMessages({ ...default_lang}));
    //     });
    }
    return null;
}
export default React.memo(Langs);